module.exports = __webpack_public_path__ + "media/assets/HWE_bespoke_entert_experience-500b5d6a6ff6f6c0b0d3b197b358b2b3.jpg";